var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"greeting-card"},[_c('h3',[_vm._v("Hello! 👋 ")]),_c('p',[_vm._v(_vm._s(_vm.Message))]),_c('div',{staticClass:"login-greeting secondary-button",on:{"click":_vm.login}},[_vm._v("Login")])])])}
var staticRenderFns = []

export { render, staticRenderFns }